import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle gs-0 gy-4 table-striped table-hover" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Dokumen PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Nomor PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Start"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Expired"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Status Dokumen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center"
}
const _hoisted_11 = {
  key: 2,
  class: "text-center"
}
const _hoisted_12 = {
  key: 3,
  class: "text-center"
}
const _hoisted_13 = {
  key: 4,
  class: "text-center"
}
const _hoisted_14 = {
  key: 5,
  class: "text-center"
}
const _hoisted_15 = {
  key: 6,
  class: "text-center"
}
const _hoisted_16 = {
  key: 7,
  class: "text-center"
}
const _hoisted_17 = {
  key: 8,
  class: "text-center"
}
const _hoisted_18 = {
  key: 9,
  class: "text-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_20 = {
  key: 10,
  class: "text-center"
}
const _hoisted_21 = {
  key: 11,
  class: "text-center"
}
const _hoisted_22 = {
  key: 12,
  class: "text-center"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/uploadkuning.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "card-body py-3" }
const _hoisted_38 = { class: "table-responsive" }
const _hoisted_39 = { class: "table align-middle gs-0 gy-4 table-striped table-hover" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "Dokumen Pendukung PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Tanggal Upload"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Sales"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Status Dokumen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Dokumen Operasional", -1)
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = {
  key: 0,
  class: "text-center"
}
const _hoisted_45 = {
  key: 1,
  class: "text-center"
}
const _hoisted_46 = {
  key: 2,
  class: "text-center"
}
const _hoisted_47 = {
  key: 3,
  class: "text-center"
}
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/uploadkuning.svg",
  alt: ""
}, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "Dokumen Pengurus", -1)
const _hoisted_58 = { class: "text-center" }
const _hoisted_59 = {
  key: 0,
  class: "text-center"
}
const _hoisted_60 = {
  key: 1,
  class: "text-center"
}
const _hoisted_61 = {
  key: 2,
  class: "text-center"
}
const _hoisted_62 = {
  key: 3,
  class: "text-center"
}
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/downloadungu.svg",
  alt: ""
}, null, -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/uploadkuning.svg",
  alt: ""
}, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { key: 2 }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = {
  key: 0,
  style: {"position":"fixed","z-index":"9998","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_81 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_82 = { class: "modal-content rounded" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-0 border-0 justify-content-center",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title pb-2 pt-2 px-4",
    style: {"color":"white"}
  }, " Upload Data ")
], -1)
const _hoisted_84 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-lg-12 fv-row" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen PKS", -1)
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "col-lg-12 fv-row" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen Operasional", -1)
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-lg-12 fv-row" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen SK Pengurus", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "text-end mt-8 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "Format dokumen .doc, .docx dan .pdf")
], -1)
const _hoisted_95 = { class: "modal-footer" }
const _hoisted_96 = {
  key: 1,
  style: {"position":"fixed","z-index":"9998","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_97 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_98 = { class: "modal-content rounded" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-0 border-0 justify-content-center",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title pb-2 pt-2 px-4",
    style: {"color":"white"}
  }, " Upload Data ")
], -1)
const _hoisted_100 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-lg-12 fv-row" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen PKS", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "text-end mb-4 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "Format dokumen .doc , .docx dan .pdf")
], -1)
const _hoisted_105 = { class: "modal-footer" }
const _hoisted_106 = {
  key: 2,
  style: {"position":"fixed","z-index":"9998","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_107 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_108 = { class: "modal-content rounded" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-0 border-0 justify-content-center",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title pb-2 pt-2 px-4",
    style: {"color":"white"}
  }, " Upload Data ")
], -1)
const _hoisted_110 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = { class: "col-lg-12 fv-row" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen SK Pengurus", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { class: "text-end mb-4 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "Format dokumen .doc , .docx dan .pdf")
], -1)
const _hoisted_115 = { class: "modal-footer" }
const _hoisted_116 = {
  key: 3,
  style: {"position":"fixed","z-index":"9999","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_117 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_118 = { class: "modal-content rounded" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-0 border-0 justify-content-center",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title pb-2 pt-2 px-4",
    style: {"color":"white"}
  }, " Upload Data ")
], -1)
const _hoisted_120 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-lg-12 fv-row" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Upload Dokumen Operasional", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", { class: "text-end mb-4 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "Format dokumen .doc , .docx dan .pdf")
], -1)
const _hoisted_125 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "card-footer d-flex justify-content-start py-6 px-9"
          }, [
            _createElementVNode("a", {
              class: "btn btn-info me-3",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadItem2 && _ctx.downloadItem2(...args)))
            }, " Download Draft Sekolah "),
            (
            item.documentLegality.documentUrl !== null ||
            item.documentLegality.documentSchoolOperational !== null ||
            item.documentLegality.documentSkPengurus !== null
          )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary me-3",
                  type: "button",
                  hidden: "",
                  "data-bs-toggle": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalAll = true))
                }, " Upload PKS "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-primary me-3",
                  type: "button",
                  "data-bs-toggle": "modal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalAll = true))
                }, " Upload PKS "))
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              (_ctx.tableData.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (item.documentLegality.typ == null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString("PKS")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString("PKS"))),
                        (item.documentLegality.number == null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString("-")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(item.documentLegality.number), 1)),
                        (item.documentLegality.startDate == null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString("-")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(item.documentLegality.startDate), 1)),
                        (item.documentLegality.expiredDate == null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString("-")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(item.documentLegality.expiredDate), 1)),
                        (item.documentLegality.status == null)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString("-")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.changeBahasa(item.documentLegality.status)), 1)),
                        _hoisted_19,
                        (item.isPksActive == true)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString("Aktif")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString("Tidak Aktif"))),
                        _createElementVNode("td", _hoisted_23, [
                          (
                        item.documentLegality.documentUrl == null ||
                        item.documentLegality.documentSchoolOperational ==
                          null ||
                        item.documentLegality.documentSkPengurus == null
                      )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "symbol symbol-35px me-2",
                                "data-bs-toggle": "tooltip",
                                title: "Download",
                                hidden: "",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.downloadPks(item.documentLegality.id))
                              }, _hoisted_26, 8, _hoisted_24))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "symbol symbol-35px me-2",
                                "data-bs-toggle": "tooltip",
                                title: "Download",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.downloadPks(item.documentLegality.id))
                              }, _hoisted_29, 8, _hoisted_27)),
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            title: "Upload",
                            style: {"cursor":"pointer"},
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalPks = true))
                          }, _hoisted_31)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_32, _hoisted_34)),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("table", _hoisted_39, [
              _hoisted_40,
              (_ctx.tableData.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createElementVNode("tr", null, [
                          _hoisted_42,
                          _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.dateTimeFull(
                        item.documentLegality
                          .documentSchoolOperationalUploadDate
                      )), 1),
                          (item.salesAreaName !== null)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(item.salesAreaName), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString("-"))),
                          (
                      item.documentLegality.documentSchoolOperational !== null
                    )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString("Tersedia")))
                            : (_openBlock(), _createElementBlock("td", _hoisted_47, _toDisplayString("Tidak Tersedia"))),
                          _createElementVNode("td", _hoisted_48, [
                            (
                        item.documentLegality.documentUrl == null ||
                        item.documentLegality.documentSchoolOperational ==
                          null ||
                        item.documentLegality.documentSkPengurus == null
                      )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Download",
                                  hidden: "",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.downloadOperational(item.documentLegality.id))
                                }, _hoisted_51, 8, _hoisted_49))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Download",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.downloadOperational(item.documentLegality.id))
                                }, _hoisted_54, 8, _hoisted_52)),
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              title: "Upload",
                              style: {"cursor":"pointer"},
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModalOprasi = true))
                            }, _hoisted_56)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_57,
                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.dateTimeFull(
                        item.documentLegality.documentSkPengurusUploadDate
                      )), 1),
                          (item.salesAreaName !== null)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(item.salesAreaName), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString("-"))),
                          (item.documentLegality.documentSkPengurus !== null)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString("Tersedia")))
                            : (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString("Tidak Tersedia"))),
                          _createElementVNode("td", _hoisted_63, [
                            (
                        item.documentLegality.documentUrl == null ||
                        item.documentLegality.documentSchoolOperational ==
                          null ||
                        item.documentLegality.documentSkPengurus == null
                      )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Download",
                                  hidden: "",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.downloadSk(item.documentLegality.id))
                                }, _hoisted_66, 8, _hoisted_64))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Download",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.downloadSk(item.documentLegality.id))
                                }, _hoisted_69, 8, _hoisted_67)),
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              title: "Upload",
                              style: {"cursor":"pointer"},
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalSk = true))
                            }, _hoisted_71)
                          ])
                        ])
                      ], 64))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_75, _hoisted_77)),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, _toDisplayString(), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModalAll)
      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _hoisted_83,
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("input", {
                      name: "filepks",
                      type: "file",
                      id: "filepks",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleFileUploadPks($event)))
                    }, null, 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("input", {
                      name: "fileoprs",
                      type: "file",
                      id: "fileoprs",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleFileUploadOperasional($event)))
                    }, null, 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("input", {
                      name: "filesk",
                      type: "file",
                      id: "filesk",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleFileUploadSk($event)))
                    }, null, 32)
                  ]),
                  _hoisted_94
                ])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-bs-dismiss": "modal",
                  style: {"background-color":"#e50200"},
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.klikreset && _ctx.klikreset(...args)))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.simpanAll()))
                }, " Simpan ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModalPks)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("input", {
                      name: "fileexcel",
                      type: "file",
                      id: "fileexcel",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleFileUploadPks($event)))
                    }, null, 32)
                  ]),
                  _hoisted_104
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-bs-dismiss": "modal",
                  style: {"background-color":"#e50200"},
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.klikreset && _ctx.klikreset(...args)))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.simpanOnlyPks(_ctx.tableData[0].documentLegality.id)))
                }, " Simpan ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModalSk)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _hoisted_109,
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("input", {
                      name: "fileexcel",
                      type: "file",
                      id: "fileexcel",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleFileUploadSk($event)))
                    }, null, 32)
                  ]),
                  _hoisted_114
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  style: {"background-color":"#e50200"},
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.klikreset && _ctx.klikreset(...args)))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.simpanOnlySk(_ctx.tableData[0].documentLegality.id)))
                }, " Simpan ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModalOprasi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _hoisted_119,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _hoisted_123,
                      _createElementVNode("input", {
                        name: "fileexcel",
                        type: "file",
                        id: "fileexcel",
                        class: "form-control form-control-lg mx-5",
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleFileUploadOperasional($event)))
                      }, null, 32)
                    ]),
                    _hoisted_124
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  style: {"background-color":"#e50200"},
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.klikreset && _ctx.klikreset(...args)))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.simpanOnlyOprs(_ctx.tableData[0].documentLegality.id)))
                }, " Simpan ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}